import { render, staticRenderFns } from "./FilterTag.vue?vue&type=template&id=0379c813&"
import script from "./FilterTag.vue?vue&type=script&setup=true&lang=js&"
export * from "./FilterTag.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports